export const API_NAMESPACE = "api";
export const USER_KEY = "userKey";
export const S3_PHOTO_BUCKET_URL =
  "https://s3bucketstack-photosbucket2ac9d1f0-1tyd187nlzl8v.s3.us-west-1.amazonaws.com/images/";
export const S3_IODT_PHOTO_BUCKET_URL =
  "https://s3bucketstack-photosbucket2ac9d1f0-1tyd187nlzl8v.s3.us-west-1.amazonaws.com/iotd/";
